import {useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {WithTranslation, withTranslation} from 'react-i18next';
import ym from 'react-yandex-metrika';

import withLayout from 'src/Components/Common/withLayout';
import LazyLoadedBlocks from 'src/Components/Home/LazyLoadedBlocks';
import Showcase from 'src/Components/Home/Showcase/Showcase';
import TechnologyStack from 'src/Components/Home/TechnologyStack/TechnologyStack';
import {EnumHomePageAnchors} from 'src/Routes/EnumHomePageAnchors';
import EnumRoutes from 'src/Routes/EnumRoutes';

const MainPage = (props: WithTranslation) => {
	useEffect(() => ym('hit', EnumRoutes.HOME));

	return (
		<>
			<Helmet>
				<title>{props.t('meta.main.title')}</title>
				<meta name="description" content={props.t('meta.main.description')} />
				<meta name="keywords" content={props.t('meta.main.keywords')} />
			</Helmet>
			<Showcase />
			<TechnologyStack anchor={EnumHomePageAnchors.TECHNOLOGY} />
			<LazyLoadedBlocks />
		</>
	);
};

export interface ITeamMember {
	name: string;
	position: string;
	photo: string;
}

export default withLayout(withTranslation('meta')(MainPage));
